import { HostService } from '../../services/host/host.service';
import { Pipe, PipeTransform, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Pipe({
  name: 'absolutePath'
})
export class AbsolutePathPipe implements PipeTransform {
  host: string;
  constructor(
    private hostService: HostService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.host = this.hostService.host2;
  }


  transform(value: string, args?: number): any {
    if (value) {
      const extension = (this.isChromeOrOpera()) ? '.webp' : '';
      return `${this.host}/${args}/${value}${extension}`
    } else {
      return 'assets/images/no-image.png'
    }
  }

  isChromeOrOpera() {
    if (isPlatformBrowser(this.platformId)) {
      return navigator.userAgent.toLowerCase().indexOf('chrome') > -1 ||
        navigator.userAgent.toLowerCase().indexOf('opera') > -1
    } else {
      return false;
    }
  }

}
